module.exports = __webpack_public_path__ + "static/media/grunt.dc580e12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/grunt.png
// module id = 107
// module chunks = 0